import React from 'react';
import { useTranslation } from 'react-i18next';

const FilesList = ({ files, onDownload, onDelete }) => {
	const { t } = useTranslation();

	return (
		<table className='table table-striped table-borderless' aria-labelledby="tabelLabel">
			<thead>
				<tr>
					<th>#</th>
					<th>{t('name')}</th>
					<th>{t('language')}</th>
					<th>{t('duration')}</th>
					<th>{t('status')}</th>
					<th>{t('progress')}</th>
				</tr>
			</thead>
			<tbody>
				{files && files.map((audioFile, index) =>
					<tr key={audioFile.id}>
						<td className="hidden-row">{index + 1}</td>
						<td>{audioFile.name}</td>
						<td data-label={t('language')}>{t(audioFile.language.toLowerCase())}</td>
						<td data-label={t('duration')} className={`${audioFile.duration !== null ? 'hidden-row' : ''}`}>
							{audioFile.duration.split('.')[0]}
						</td>
						<td data-label={t('status')}>{t(audioFile.status.toLowerCase())}</td>
						<td data-label={t('progress')} className={`${audioFile.status !== "Transcribing" ? 'hidden-row' : ''}`}>
							{audioFile.progress !== undefined && audioFile.progress + "%"}
						</td>
						<td className="d-lg-flex justify-content-end">
							{audioFile.status === "Done" &&
								<button
									className="btn btn-secondary"
									onClick={() => onDownload(audioFile)}>
									{t('download')}
								</button>
							}
							<button
								className="btn btn-danger"
								disabled={audioFile.status === "Transcribing" ? true : false}
								onClick={() => onDelete(audioFile.id)}>
								{t('delete')}
							</button>
						</td>
					</tr>
				)}
			</tbody>
		</table>
	);
}

export default FilesList;